import React, { Component } from 'react';
import { connect } from 'react-redux';

class DynamicFom extends Component {

    componentDidUpdate() {
        this.refs.myForm.submit();
    }

    renderForm = () => {
        let formElements = [];
        for(let key in this.props.rMap) {
            if(this.props.rMap.hasOwnProperty(key)) {
                const inputField = <input type="hidden" name={key} value={this.props.rMap[key]} />
                formElements.push(inputField)
            }
        }
        return formElements;
    }

    render() {
        return (
            <form ref="myForm" action={this.props.rurl} method="post">
                {this.renderForm()}
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        rurl: state.payments.rurl,
        rMap: state.payments.rMap
    }
}

export default connect(mapStateToProps)(DynamicFom);


// WEBPACK FOOTER //
// ./src/components/Payment/DynamicForm/DynamicForm.js